import MainLayout from './MainLayout'
import BlankLayout from './BlankLayout'

export {
  MainLayout,
  BlankLayout
}



// WEBPACK FOOTER //
// ./src/layout/index.js